import { Alert, SegmentedControl, Stack, Text } from "@mantine/core";
import type { WallVoiceMode } from "@/types/ai-assistant-voice";

interface Props {
	value: WallVoiceMode;
	error?: string;
	disabled: boolean;
	onChange: (mode: WallVoiceMode) => void;
}

const MODE_OPTIONS: { value: WallVoiceMode; label: string }[] = [
	{ value: "off", label: "Nonaktif" },
	{ value: "noc", label: "Mode NOC" },
	{ value: "full", label: "Penuh" },
];

const MODE_HELP: Record<WallVoiceMode, string> = {
	off: "Tidak ada suara di /wall. Server menolak sesi suara dari akun kiosk di mana pun.",
	noc: "Untuk operator NOC di ruang TV: mikrofon tertutup sampai tombol bicara ditahan (bawaan), volume bisa diatur, dan jawaban diketik tidak dibacakan. Atur perilaku mikrofon di bawah.",
	full: "Panel suara sama seperti di dashboard, memakai kuota menit akun kiosk.",
};

/** Setelan "Mode suara di wall": pilihan tiga mode + penjelasan risiko gema untuk mode yang membuka mikrofon. */
export function WallVoiceModeField({
	value,
	error,
	disabled,
	onChange,
}: Props) {
	return (
		<Stack gap="xs" data-wall-voice-mode>
			<Text size="sm" fw={500}>
				Mode suara di wall
			</Text>
			<SegmentedControl
				data={MODE_OPTIONS}
				value={value}
				onChange={(v) => onChange(v as WallVoiceMode)}
				disabled={disabled}
			/>
			<Text size="xs" c={error ? "red" : "dimmed"}>
				{error ?? MODE_HELP[value]}
			</Text>
			{value !== "off" ? (
				<Alert color="yellow" variant="light" p="xs">
					<Text size="xs">
						Risiko gema: speaker TV yang dekat mikrofon bisa membuat Jenna
						mendengar suaranya sendiri lalu menjawab terus-menerus. Gunakan
						mikrofon dengan peredam gema atau headset. Sesi otomatis mati bila
						hening sesuai batas di atas.
					</Text>
				</Alert>
			) : null}
		</Stack>
	);
}
